import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import Loader from './Loader/Loader';

class ConfirmationMessage extends React.Component {
    constructor() {
        super();
        this.state = { DuringApprove: false, checkboxState: false };
    }
    onHideHandler = () => {
        if (this.props.OnHide) {
            this.props.OnHide();
        } else if (!this.props.disableHide) {
            this.closeForm();
        }
    };
    closeForm() {
        this.props.OnCancel();
    }
    approveForm() {
        this.setState({ DuringApprove: true });
        this.props.OnApprove((result, err) => {
            if (!result) {
                this.setState({ error: err, DuringApprove: false });
            } else {
                this.setState({ error: null, DuringApprove: false });
            }
        }, this.state.checkboxState);
    }
    onCheckChanged(checked) {
        this.setState({ checkboxState: checked });
    }
    componentDidMount() {
        this.setState({ checkboxState: !!this.props.checkBoxInitialState });
    }
    render() {
        const title = this.props.title || 'Are you sure?';
        const bodyText = this.props.body || null;
        const approveButtonText = this.props.approveText || 'OK';
        const checkBoxInitialState = !!this.props.checkBoxInitialState;
        const errorMessage = this.state.error;
        const approveButtonStyle = this.props.approveStyle || 'success';
        const cancelButtonText = this.props.cancelText || 'Cancel';
        const disableCloseButton = this.props.disableCloseButton || false;

        return (
            <Modal
                enforceFocus={false}
                keyboard={true}
                id="confirmationDialogModal"
                className={this.props.className}
                dialogClassName={this.props.dialogClass ? this.props.dialogClass : 'modal-lg'}
                show={true}
                onHide={this.onHideHandler}
                dark={this.props.dark ? 'true' : ''}
                backdrop="static">
                <Modal.Header closeButton={!disableCloseButton}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={this.props.checkboxText ? 'textBold' : ''}>{bodyText}</div>
                    {this.props.checkboxText && (
                        <div className="sfcheckbox">
                            <input
                                id={'confirnmationCheckbox'}
                                type="checkbox"
                                name={'confirnmationCheckbox'}
                                defaultChecked={checkBoxInitialState}
                                onChange={(e) => this.onCheckChanged(e.target.checked)}
                            />
                            <label className="checkboxLabel" htmlFor={'confirnmationCheckbox'}>
                                {this.props.checkboxText}
                                {this.props.checkboxExtraData}
                            </label>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className={(this.state.DuringApprove || this.props.loading) && 'disabled'}>
                    {errorMessage && <div className="error shown">{errorMessage}</div>}
                    {this.props.loading && (
                        <div className="loaderContainer">
                            <Loader />
                            {this.props.loadingText && <div>{this.props.loadingText}</div>}
                        </div>
                    )}
                    {!this.props.hideCancelButton && (
                        <Button className="cancle" onClick={() => this.closeForm(this)}>
                            {cancelButtonText}
                        </Button>
                    )}
                    {this.props.OnApprove && (
                        <Button bsStyle={approveButtonStyle} onClick={() => this.approveForm()}>
                            {approveButtonText}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ConfirmationMessage;
